(function() {
    'use strict';

    angular.module("order")
        .controller('OperationPkoController', OperationPkoController);

    OperationPkoController.$inject = ['$scope', 'momentSrvc', 'operationTypeOptions', 'operationMessagesConst', 'operationDataSrvc', 'downloadLinkSrvc', 'notificationSrvc'];

    function OperationPkoController($scope, momentSrvc, operationTypeOptions, operationMessagesConst, operationDataSrvc, downloadLinkSrvc, notificationSrvc) {
        var self = this;

        self.downloadLoading = false;
        self.filterData = {
            file: null
        };

        self.operationTypeOptions = operationTypeOptions;

        self.getOperations = getOperations;
        $scope.inputFileChange = inputFileChange;

        activate();

        function activate() {
        }

        function getOperations() {
            if (self.filterData.file) {
                self.downloadLoading = true;
                operationDataSrvc.pko(self.filterData).$promise.then(
                    function (response) {
                        downloadLinkSrvc.saveFile(response);
                        self.downloadLoading = false;
                    },
                    function (response) {
                        notificationSrvc.notification("error", operationMessagesConst.downloadError);
                        self.downloadLoading = false;
                    }
                )
            }
        }

        function inputFileChange(elem) {
            $scope.$apply(function () {
                if (elem.files.length) {
                    self.filterData.file = elem.files[0];
                } else {
                    self.filterData.file = null;
                }
            });
        }

    }
})();
